import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./card_slide.css";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";

const NextArrow = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="absolute cursor-pointer lg:-right-10  bg-[rgba(0,0,0,0.2)] p-4  -right-1 top-[47%]"
    >
      <AiOutlineArrowRight />
    </div>
  );
};
const PrevArrow = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="absolute cursor-pointer lg:-left-10  bg-[rgba(0,0,0,0.2)] p-4  -md:-left-2 left-2 z-50 top-[47%] "
    >
      <AiOutlineArrowLeft />
    </div>
  );
};

const CardSlide = ({ SlideData, title }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
          centerMode: true,
          infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          centerMode: true,
          infinite: true,
        },
      },
    ],
  };

  return (
    <>
      <div className="mt-14">
        <h1 className=" text-center mb-10 text-[22.5px] px-10 font-bold ">
          {title}
        </h1>
      </div>
      <Slider {...settings}>
        {SlideData?.map((item) => (
          <div className="mb-10 ">
            <div
              className=" w-full  flex flex-col gap-4 rounded-lg h-[400px] p-4 mt-1 relative mb-0"
              key={item.id}
            >
              <div
                floated={false}
                className="   rounded-none flex-col flex  items-center"
              >
                <img
                  src={item.img}
                  alt="profile-picture"
                  className=" max-h-48 w-full  object-contain"
                />
              </div>
              <div className="text-start pl-1">
                <div className=" ">
                  <div
                    variant=""
                    color="blue-gray"
                    className="mx-2 mt-4 text-lg text-[#8CB0B1]"
                  >
                    {item.price}
                  </div>
                  <div
                    color="blue"
                    className=" text-xs tracking-wide leading-5  text-[18px] mt-2 px-2 textfont"
                    textGradient
                  >
                    {item.cate.slice(0, 100)}
                  </div>
                  <div className="px-2 mt-2 text-font text-[14px]">
                    {item.label}
                  </div>
                </div>
              </div>
            </div>
            <div className=" mt-auto text-center ">
              <button className="capitalize titlefont px-4 py-2 border-2 rounded-xl hover:bg-white bg-black text-white hover:text-black transition-all border-black  ">
                quick shop
              </button>
            </div>
          </div>
        ))}
      </Slider>
    </>
  );
};

export default CardSlide;
